import { Tr } from "@chakra-ui/react"

const Row = (props) => <Tr cursor="pointer" _hover={{ backgroundColor: 'rgba(0,0,0,0.05)' }} {...props}></Tr>

export default Row